<template>
    <div>

      <ed-modal 
        :title="(formData.item ? formData.item._nome+' :: LOGS' : '')" 
        :modal="showLogs" 
        :isModal="false"
        width="97%"
      >
        <div slot="modal-content">
            <el-tabs type="card" v-model="tabSelected">

              <el-tab-pane label="Erro" name="error" v-if="formData.item && formData.item && formData.item.log_erro.length">

                  <span slot="label">
                      <i class="fa fa-times-circle"></i> Erro
                      <span v-if="formData.item && formData.item.log_erro"> ({{formData.item.log_erro.length}})</span>
                  </span>

                  <table class="table">
                      <thead>
                        <tr>
                          <th>Descrição</th>
                        </tr>
                      </thead>

                      <tbody>

                        <tr v-if="!formData.item || !formData.item.log_erro || formData.item.log_erro.length == 0">
                          <td align="center">
                            Nenhum erro encontrado
                          </td>
                        </tr>

                        <tr v-else v-for="(item,key) in formData.item.log_erro" :key="key">
                          <td align="left" style="color:red">

                              <span v-if="item['risco_vinculo']">
                                  <p style="color:#666"><b>RISCO SEM VÍNCULO COM ESOCIAL</b></p>
                                  <p style="color:#666;font-size:9pt"><i>Acesse o menú Configurações > Riscos para atualizar corretamente os riscos abaixo.</i></p>
                                  <p v-for="(risco,i) in item['risco_vinculo']" style="padding-left:15px" :key="i">
                                      {{risco}}
                                  </p>
                              </span>

                              <span v-else-if="item['exame_vinculo']">
                                  <p style="color:#666"><b>EXAME SEM VÍNCULO COM ESOCIAL OU COM PROBLEMA DE CADASTRO</b></p>
                                  <p style="color:#666;font-size:9pt"><i>Acesse o menú Configurações > Exames para atualizar corretamente os exames abaixo.</i></p>
                                  <p v-for="(exame,i) in item['exame_vinculo']" style="padding-left:15px" :key="i">
                                      {{exame}}
                                  </p>
                              </span>

                              <span v-else-if="item['cadastro_medico']">
                                  <p style="color:#666"><b>CADASTRO DO MÉDICO EXAMINADOR INVÁLIDO</b></p>
                                  <p style="color:#666;font-size:9pt"><i>Acesse o menú Configurações > Médicos Examinadores para atualizar corretamente o médico da consulta.</i></p>
                                  <p v-for="(exame,i) in item['cadastro_medico']" style="padding-left:15px" :key="i">
                                    {{exame}}
                                  </p>
                              </span>

                              <span v-else-if="item['cadastro_funcionario']">
                                  <p style="color:#666"><b>CADASTRO DO TRABALHADOR INVÁLIDO</b></p>
                                  <p style="color:#666;font-size:9pt"><i>Acesse o menú Empresa > Funcionários para atualizar corretamente os dados do trabalhador.</i></p>
                                  <p v-for="(risco,i) in item['cadastro_funcionario']" style="padding-left:15px" :key="i">
                                      {{risco}}
                                  </p>
                              </span>

                              <span v-else-if="item['cadastro_reg_amb']">
                                  <p style="color:#666"><b>CADASTRO RESPONSÁVEL TÉCNICO INVÁLIDO</b></p>
                                  <p style="color:#666;font-size:9pt"><i>Acesse o menú PPRA/PGR > Gerenciar para atualizar corretamente os dados do responsável pelo PGR.</i></p>
                                  <p  v-for="(posicoes,i) in item['cadastro_reg_amb']" style="padding-left:15px" :key="i">
                                      <b v-if="posicoes.posicao">{{posicoes.posicao}}:</b>

                                      <span v-if="posicoes.msg">{{posicoes.msg}}</span>
                                      <span v-else>{{posicoes}}</span>
                                  </p>
                              </span>

                              <span v-else-if="item['cadastro_ppp_fdt']">
                                  <p style="color:#666"><b>CADASTRO DA EXPOSIÇÃO A FATORES DE RISCOS INVÁLIDO</b></p>
                                  <p style="color:#666;font-size:9pt"><i>Acesse o menú LTCAT > Gerenciar para atualizar corretamente as medições do LTCAT desse trabalhador.</i></p>
                                  <p  v-for="(posicoes,i) in item['cadastro_ppp_fdt']" style="padding-left:15px" :key="i">
                                      <span v-if="posicoes.msg">{{posicoes.msg}}</span>
                                      <span v-else>{{posicoes}}</span>
                                  </p>
                              </span>

                              <span v-else-if="item['erro_cadastro_fdt']">
                                  <p style="color:#666"><b>CADASTRO DA FRENTE DE TRABALHO INVÁLIDO</b></p>
                                  <p style="color:#666;font-size:9pt"><i>Acesse o menú Empresa > Editar > Frente de Trabalho > Editar para atualizar corretamente a frente de trabalho.</i></p>
                                  <p v-for="(risco,i) in item['erro_cadastro_fdt']" style="padding-left:15px" :key="i">
                                      {{risco}}
                                  </p>
                              </span>

                              <span v-else-if="item['cadastro_sem_risco']">
                                  <p style="color:#666"><b>NENHUM RISCO FOI ENCONTRADO</b></p>
                                  <p style="color:#666;font-size:9pt"><i>Acesse o menú PCMSO > Gerenciar para atualizar corretamente o documento PPRA ou PCMSO.</i></p>
                                  <p v-for="(risco,i) in item['cadastro_sem_risco']" style="padding-left:15px" :key="i">
                                      {{risco}}
                                  </p>
                              </span>

                              <span v-else-if="item['error_cadastro_epi']">
                                  <p style="color:#666"><b>EPI CADASTRADO INCORRETAMENTE</b></p>
                                  <p style="color:#666;font-size:9pt"><i>Acesse o menú LTCAT > Gerenciar para atualizar corretamente as medições no documento.</i></p>
                                  <template v-for="(epis,i) in item['error_cadastro_epi']" style="padding-left:15px;" >
                                      <p :key="i" style="color:#000000">
                                        <b>{{i}}</b>
                                      </p>
                                      
                                      <p v-for="epi in epis" :key="epi">
                                        {{epi}}
                                      </p>
                                  </template>
                              </span>

                              <span v-else-if="item['cadastro']">
                                  <p style="color:#666"><b>CADASTRO INVÁLIDO</b></p>
                                  <p v-for="(risco,i) in item['cadastro']" style="padding-left:15px" :key="i">
                                      {{risco}}
                                  </p>
                              </span>


                              <span v-else-if="item['cadastro_abs']">
                                  <p style="color:#666"><b>CADASTRO DO ABSENTEÍSMO INVÁLIDO</b></p>
                                    <p style="color:#666;font-size:9pt"><i>Acesse o menú Absenteísmo > Gerenciar para atualizar corretamente o registro que está com erro</i></p>
                                  <p v-for="(risco,i) in item['cadastro_abs']" style="padding-left:15px" :key="i">
                                      {{risco}}
                                  </p>
                              </span>

                              <span v-else-if="item['erro_cadastro_setor']">
                                  <p style="color:#666"><b>CADASTRO DO GHE (SETOR) INCORRETO</b></p>
                                  <p style="color:#666;font-size:9pt"><i>Acesse o menú PPRA/PGR > Gerenciar para atualizar corretamente o GHE (Setor) em questão</i></p>
                                  <p v-for="(risco,i) in item['erro_cadastro_setor']" style="padding-left:15px" :key="i">
                                      {{risco}}
                                  </p>
                              </span>

                              <span v-else-if="item['erro_cadastro_atividade_funcao']">
                                  <p style="color:#666"><b>DESCRIÇÃO DE ATIVIDADES DA FUNÇÃO NÃO INFORMADA</b></p>
                                  <p style="color:#666;font-size:9pt"><i>Acesse o menú PPRA/PGR > Gerenciar, selecione o GHE (Setor) indicado e preencha a descrição de atividades da função do trabalhador</i></p>
                                  <p v-for="(risco,i) in item['erro_cadastro_atividade_funcao']" style="padding-left:15px" :key="i">
                                      {{risco}}
                                  </p>
                              </span>

                              <span v-else-if="item['erro_cadastro_fator_risco']">
                                  <p style="color:#666"><b>FATOR DE RISCO SEM DESCRIÇÃO DA METODOLOGIA</b></p>
                                  <p style="color:#666;font-size:9pt"><i>Acesse o menú Configurações > Fatores de Risco para preencher a descrição da metodologia do fator de risco indicado</i></p>
                                  <p v-for="(risco,i) in item['erro_cadastro_fator_risco']" style="padding-left:15px" :key="i">
                                      {{risco.msg ? risco.msg : risco}}
                                  </p>
                              </span>

                              <span v-else-if="item['erro_cadastro_epi_risco']">
                                  <p style="color:#666"><b>EPI NÃO CADASTRADO PARA O RISCO</b></p>
                                  <p style="color:#666;font-size:9pt"><i>Acesse o menú PPRA/PGR > Gerenciar, selecione o GHE (Setor) e vincule um ou mais EPIs ao risco indicado</i></p>
                                  <p v-for="(risco,i) in item['erro_cadastro_epi_risco']" style="padding-left:15px" :key="i">
                                      {{risco.msg ? risco.msg : risco}}
                                  </p>
                              </span>

                              <span v-else-if="item['erro_cadastro_reg_amb']">
                                  <p style="color:#666"><b>NENHUMA MEDICAÇÃO FOI CADASTRADO PARA ESSE LTCAT</b></p>
                                  <p style="color:#666;font-size:9pt"><i>Acesse o menú Ltcat > Gerenciar para atualizar corretamente as medições do GHE (Setor) do funcionário em questão.</i></p>
                              </span>

                              <span v-else="!item['risco_vinculo']"><p>{{item}}</p></span>
                          </td>
                        </tr>

                      </tbody>
                  </table>

              </el-tab-pane>

              <el-tab-pane label="Pontos de Atenção"  name="warning" v-if="formData.item && formData.item && formData.item.log_warning.length">

                  <span slot="label">
                      <i class="fa fa-exclamation-circle"></i> Pontos de Atenção
                      <span v-if="formData.item && formData.item.log_warning"> ({{formData.item.log_warning.length}})</span>
                  </span>

                  <table class="table">
                      <thead>
                        <tr>
                          <th>Descrição</th>
                        </tr>
                      </thead>

                      <tbody>

                        <tr v-if="!formData.item || !formData.item.log_warning|| formData.item.log_warning.length == 0">
                          <td align="center">
                            Nenhum ponto de atenção encontrado
                          </td>
                        </tr>

                        <tr v-else v-for="(item,key) in formData.item.log_warning" :key="key">
                          <td align="left" style="color:#ff8300">
                              <span><p v-html="item"></p></span>
                          </td>
                        </tr>

                      </tbody>
                  </table>

              </el-tab-pane>

              <!-- <el-tab-pane label="Processamento do Arquivo"  name="file" v-if="formData.item && formData.item && formData.item.log_retorno  && formData.item.log_retorno.length">

                  <span slot="label">
                      <i class="fa fa-search"></i> Processamento do Arquivo
                      <span v-if="formData.item && formData.item.log_retorno"> (1)</span>
                  </span>

                  <table class="table">
                      <thead>
                      <tr>
                          <th>Status</th>
                          <th>Recibo</th>
                      </tr>
                      </thead>

                      <tbody>

                          <tr>
                            <td align="left">{{formData.item.status}}</td>
                            <td align="left">{{formData.item.recibo}}</td>
                          </tr>

                          <tr v-for="(ocorrencia,key) in formData.item.log_retorno.ocorrencias" :key="key">
                              <td align="left" style="color:red">
                                  {{ocorrencia.codigo}}
                              </td>
                              <td align="left" style="color:red">
                                  {{ocorrencia.descricao}}
                              </td>
                          </tr>

                          <tr>
                              <td align="center" colspan="2" style="color:blue">
                                  <b>Protocolo de Envio:</b>
                                  {{formData.item.log_retorno.protocolo}}
                              </td>
                          </tr>

                      </tbody>
                  </table>

              </el-tab-pane> -->

          </el-tabs>
        </div>
      </ed-modal>



    </div>
</template>

<script>

    import Fct from 'common/fct'
    import EdModal from 'common/modal'

    export default {
        name:"esocial-logs",
        mixins:[],
        components:{EdModal},

        props:{

          showForm:{
            type: Boolean,
            default: false
          },

          formData:{
            type: Object,
            default: {}
          },

        },

        watch:{
          showForm(){
            this.showLogs = !this.showLogs;
            this.initialize()
          },

          formData(){
          },

        },

        data () {
          return {
            showLogs: false,
            tabSelected: 'error'
          }
        },

        created(){
        },

        mounted() {
          this.initialize()
        },

        methods:{
          initialize(){
            if(this.formData.item && this.formData.item && this.formData.item.log_erro.length){
                this.tabSelected = 'error'
            }
            else if(this.formData.item && this.formData.item && this.formData.item.log_warning.length){
               this.tabSelected = 'warning'
            }
            else{
              this.tabSelected = 'file'
            }
          }
        }
    }
</script>



// WEBPACK FOOTER //
// logs.vue?6525fc3c